export const fronturls = {
	//Front end URLS to be entered here
	Home:"/home",
	Help:"/help",
	ContactUs:"/contact-us",
	StudentLogin:"/student-login",
	AdminLogin:"/admin-login",
	Acknowledgements:"/acknowledgements",
	StudentDashboard:'/student-dashboard',
	AdminDashboard:"/admin-dashboard",
	CodeGeneration:"/generate-codes",
	ForgotPassword: "/forgot-password",
	Resources:"/resources",
	Feedback:"/feedback",
	Users:"/users",
	Codes:"/codes",
	AdminUsers:"/admin-users",
	StudentUsers:"/student-users",
	Logout:"/logout",
	MyProfile:"/my-profile",
	Images:"/image-listing",
	Videos:"/video-listing",
	VideoPreview:"/video-preview",
	ResetPassword: "/reset-password",
	Registration: "/registration",
	Profile: "/profile",
	Listing: '/listing',
	EditUser: "/edit-user",
	Activation: "/activation",
	ViewPdf: "/view-pdf",
	ResendEmail: "/resend-email",
	Animation: "/animation-listing",
	AnimationPreview: "/animation-preview",
	InvalidBookCode: "/why-is-my-book-code-invalid",
	AccessOnlineResources: "/how-do-i-access-the-online-resources",
	FindAccessCode: "/how-do-i-find-the-access-code-to-register-for-the-practice-exams",
	UseMyCode: "/can-someone-else-use-my-subscription",
	DidNotReceiveMail: "/i-did-not-receive-an-email-after-registration-what-do-i-do",
	NotReceiveMails:"/i-am-not-receiving-mails-from-this-site",
	ForgottenUsernamePassword: "/what-should-i-do-if-i-have-forgotten-my-username-or-password",
	AccAccessInfo: "/how-long-will-i-be-able-to-access-my-account",
	CannotAccessOnlineResources: "/what-should-i-do-if-i-cannot-access-the-online-resources",
	CannotLoginAccount: "/why-can-t-i-login-my-account",
	ImageUpdate: "/image-update",
	UniversityListing: "/university-master",
	AddUniversity: "/add-university",
	VideoEdit: "/video-edit",
	AnimationEdit: "/animation-edit",
	CodesListing: "/book-code-list",
	ResourceListing: "/resource-listing",
	DocumentsListing: "/document-listing",
	ViewDocument: "/view-document",
	Policies: "/policies",
	Settings: "/settings",
	CronActivity: "/cron-activity",
	Responsedata: "/response-data",
}
